import * as preact from "preact";
import PropTypes from "prop-types";

import classname from "../../foundation/utils/classname";

import "./style.css";

const { h } = preact;

function Button(props) {
    const {
        children,
        baseRef,
        class: className,
        style,
        type,
        disabled,
        inverted,
        ninja,
        primary,
        secondary,
        warning,
        onClick,
        onMouseDown,
        onMouseEnter,
        onMouseLeave,
        "data-testid": dataTestid,
        title
    } = props;

    const classnames = classname("button", className, {
        inverted: !!inverted,
        ninja: !!ninja,
        primary: !!primary,
        secondary: !!secondary,
        warning: !!warning
    });
    return (
        <button
            style={style}
            ref={baseRef}
            type={type}
            disabled={disabled}
            title={title}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            data-testid={dataTestid}
            class={classnames}>
            {children}
        </button>
    );
}

Button.propTypes = {
    /** External class name to be added to the root element, which is a `<button>`. */
    class: PropTypes.string,
    /** External style to be added to the root element, which is a `<button>`. */
    style: PropTypes.object,
    /** Whether the button disabled. */
    disabled: PropTypes.bool,
    /** Button's child nodes. */
    children: PropTypes.node,
    /** Called on user's click. */
    onClick: PropTypes.func,
    /** Whether to apply Zeplin primary button theme or not. */
    primary: PropTypes.bool,
    /** Whether to apply Zeplin secondary button theme or not. */
    secondary: PropTypes.bool
};

Button.defaultProps = {
    type: "button"
};

export default Button;
